module.exports = __webpack_public_path__ + "static/media/11.3149030f.jpg";